<template>
  <q-dialog v-model="confirm" persistent>
    <q-card
      class="column no-wrap col-6"
      :style="{
        'min-height': height === '' ? '300px' : height,
        'max-height': height === '' ? '300px' : height,
        width: !width ? '500px' : width,
      }"
    >
      <q-card-section class="column">
        <span style="color: #21324a" class="mensagem-text">{{ mensagem }}</span>
        <q-separator style="height: 1px; background-color: #21324a" />
      </q-card-section>

      <section style="color: #21324a; padding: 0px 17px">
        {{ subMensagem }}
      </section>

      <q-card-section
        v-if="showConteudo"
        :style="{
          'min-height': intern_height === '' ? '176px' : intern_height,
          'max-height': intern_height === '' ? '150px' : intern_height,
          width: !width ? '500px' : width,
        }"
        style="overflow-y: scroll"
      >
        <slot></slot>
      </q-card-section>

      <q-card-actions
        :style="{ 'justify-content': esconderConfirme ? '' : 'space-between' }"
        class="row col-12"
        align="right"
      >
        <q-btn
          v-if="!esconderConfirme"
          label="Confirmar"
          :disabled="desabilitarConfirme"
          no-caps
          class="q-mt-sm"
          icon="done"
          v-close-popup
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: normal;
          "
          @click="$emit('resultado', true)"
        />
        <q-btn
          v-if="showCancelar"
          icon="close"
          no-caps
          label="Cancelar"
          v-close-popup
          style="
            background-color: white;
            border-radius: 8px;
            color: #21324a;
            font-weight: normal;
            border: 1px solid #21324a;
          "
          @click="$emit('resultado', false)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { watch, ref } from "vue";
export default {
  props: [
    "mensagem",
    "exibir",
    "desabilitarConfirme",
    "subMensagem",
    "showCancelar",
    "height",
    "width",
    "intern_height",
    "showConteudo",
    "esconderConfirme",
  ],
  setup(props) {
    const confirm = ref(false);

    watch(
      () => props.exibir,
      () => {
        confirm.value = props.exibir;
      }
    );
    return {
      confirm,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
